import { render, staticRenderFns } from "./MediaDashboard.vue?vue&type=template&id=0fcb07a2"
import script from "./MediaDashboard.vue?vue&type=script&lang=js"
export * from "./MediaDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports